/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Transaction } from './Transaction';
import {
    TransactionFromJSON,
    TransactionFromJSONTyped,
    TransactionToJSON,
} from './Transaction';

/**
 * 
 * @export
 * @interface TransactionsPage
 */
export interface TransactionsPage {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof TransactionsPage
     */
    transactions: Array<Transaction>;
    /**
     * 
     * @type {number}
     * @memberof TransactionsPage
     */
    totalNr: number;
}

/**
 * Check if a given object implements the TransactionsPage interface.
 */
export function instanceOfTransactionsPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "transactions" in value;
    isInstance = isInstance && "totalNr" in value;

    return isInstance;
}

export function TransactionsPageFromJSON(json: any): TransactionsPage {
    return TransactionsPageFromJSONTyped(json, false);
}

export function TransactionsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(TransactionFromJSON)),
        'totalNr': json['total_nr'],
    };
}

export function TransactionsPageToJSON(value?: TransactionsPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': ((value.transactions as Array<any>).map(TransactionToJSON)),
        'total_nr': value.totalNr,
    };
}

